export default function (self, fields) {
  //TODO: Disable if rostering is not enabled

  const Fields = {
    title: `Unsubscribed`,
    minimum: 1,
    maximum: 1,
    key: "join_unsubscribe_email",
    asObject: true,
    type: "group",
    fields: [
      {
        title: "Email Address",
        minimum: 0,
        maximum: 0,
        key: "emails",
        type: "email",
        widget: "email",
      },
    ],
  };

  fields.push(Fields);
}
